let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7D0ce")).then(() => parcelRequire('69I1h'));